import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import{ ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-itfacility-rejectionform',
  templateUrl: './itfacility-rejectionform.component.html',
  styleUrls: ['./itfacility-rejectionform.component.scss']
})
export class ITfacilityRejectionformComponent implements OnInit {
public itfacilityreject_data:any={};
  constructor(public appservice:AppService, public toastr:ToastrService) { }
onApprove(){
  this.itfacilityreject_data.status='Approved';
  this.itfacilityreject_data.approvedby=this.appservice.username;
   this.appservice.postTable("api/Transaction/insertItFacilityform",this.itfacilityreject_data).subscribe((res:any)=>{
    this.toastr.success("Approved successfully!");
    //this.appservice.get_finalItFacilitygrid();
    this.appservice.goback();
  this.appservice.ITfacilityrejectGrid();
   });
  
  
}
onDecline(){
   this.itfacilityreject_data.status='Rejected';
  this.itfacilityreject_data.approvedby=this.appservice.username;
   this.appservice.postTable("api/Transaction/insertItFacilityform",this.itfacilityreject_data).subscribe((res:any)=>{
    this.toastr.success("Approved successfully!");
    //this.appservice.get_finalItFacilitygrid();
    this.appservice.goback();
  this.appservice.ITfacilityrejectGrid();
   });
  
}
back(){
  this.appservice.goback();
  this.appservice.ITfacilityrejectGrid();
  
}
onformload(){
  this.appservice.getTable("api/Transaction/ITfacilityReject_editdata?id="+this.appservice.ItfacilityReject_editid).subscribe((res:any)=>{
    if(res!=""){
      this.itfacilityreject_data=JSON.parse(res).record[0];
      console.log("the edit data of itfacility rejection form",this.itfacilityreject_data.IR_CheckerStatus)
    }
  });
}
  ngOnInit(): void {
    this.onformload();
  }

}
